<aside
  class="top-level-side-menu"
  [class.top-level-side-menu--expanded]="expanded()"
  [class.top-level-side-menu--collapsed]="!expanded()"
  [class.top-level-side-menu--pinned]="pinned()"
  (mouseleave)="onMouseLeave()">
  <div class="top-level-side-menu__header">
    <button
      type="button"
      mat-icon-button
      class="top-level-side-menu__pin"
      [class.top-level-side-menu__pin--active]="pinned()"
      (click)="togglePin()"
      [matTooltip]="(pinned() ? 'top-level-side-menu.unpin' : 'top-level-side-menu.pin') | translate"
      matTooltipPosition="right"
      [attr.aria-label]="(pinned() ? 'top-level-side-menu.unpin' : 'top-level-side-menu.pin') | translate"
      [attr.aria-pressed]="pinned()"
      data-test="top-level-pin">
      <mat-icon>push_pin</mat-icon>
    </button>
  </div>

  <nav class="top-level-side-menu__nav" (mouseenter)="onMouseEnter()">
    @for (item of items(); track item.translationKey) {
      <a
        class="top-level-side-menu__item"
        [class.top-level-side-menu__item--active]="isActive(item)"
        [class.top-level-side-menu__item--new]="item.newTag"
        [routerLink]="item.url"
        [matTooltip]="item.translationKey | translate"
        [matTooltipDisabled]="expanded()"
        matTooltipPosition="right"
        (click)="onItemClick(item, $event)"
        [attr.data-test]="item.dataTest">
        <span class="top-level-side-menu__item-icon-wrap">
          <mat-icon class="top-level-side-menu__item-icon material-icons-outlined">{{ item.icon }}</mat-icon>
          @if (hasNewBadge(item)) {
            <span class="top-level-side-menu__item-dot" aria-hidden="true"></span>
          }
        </span>
        <span class="top-level-side-menu__item-label">{{ item.translationKey | translate }}</span>
        @if (item.newTag) {
          <span class="top-level-side-menu__item-new-tag">NEW</span>
        }
        @if (item.adminOnly || item.adminTag) {
          <mat-icon class="top-level-side-menu__item-admin-tag">font_download</mat-icon>
        }
      </a>
    }

    @if (createAction(); as create) {
      <a
        class="top-level-side-menu__item top-level-side-menu__item--create"
        [routerLink]="create.url"
        [queryParams]="create.queryParams"
        [matTooltip]="'generic.create' | translate"
        [matTooltipDisabled]="expanded()"
        matTooltipPosition="right"
        data-test="top-level-create-button">
        <span class="top-level-side-menu__item-icon-wrap">
          <mat-icon class="top-level-side-menu__item-icon material-icons-outlined">add</mat-icon>
        </span>
        <span class="top-level-side-menu__item-label">{{ "generic.create" | translate }}</span>
      </a>
    }
  </nav>

  <div class="top-level-side-menu__footer" (mouseenter)="onMouseEnter()">
    <app-mega-menu></app-mega-menu>
  </div>
</aside>
